module.exports = __webpack_public_path__ + "323537c43acecaa576dd2011405ef05e.png";